var _path, _rect, _path2, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.5L8 11.5",
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 10,
    width: 3,
    height: 3,
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.6616C14.3732 6.27287 13.4449 5.07942 12.2989 4.189C11.153 3.29857 9.82535 2.73922 8.43602 2.56145C7.04668 2.38368 5.63936 2.59308 4.34112 3.17075C3.04289 3.74842 1.89462 4.67616 1 5.87022L2.29448 7.0669C3.01017 6.11165 3.92879 5.36946 4.96738 4.90732C6.00596 4.44518 7.13182 4.27766 8.24329 4.41988C9.35476 4.5621 10.4168 5.00958 11.3336 5.72192C12.2504 6.43426 12.9931 7.38902 13.4945 8.5L15 7.6616Z",
    fill: "#00C2FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 7,
    width: 3,
    height: 3,
    fill: "white",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 5,
    width: 3,
    height: 3,
    fill: "white",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHu);
export default __webpack_public_path__ + "static/media/hu.eebe441c6758b9333913d783066bc783.svg";
export { ForwardRef as ReactComponent };